// Meta Pixel config. Only hotels listed here ever load or fire a pixel.
// TODO backend: move to API/DB-driven config if more hotels need pixels
const META_ENABLED = true; // kill switch: set false + redeploy to turn everything off

const META_PIXELS = {
  '28': '3951449221823708', // WH Tarangi Ramganga
};

let scriptLoaded = false;
const initedPixels = new Set();

const loadFbq = () => {
  if (scriptLoaded) return;
  scriptLoaded = true;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
};

export const getMetaPixelId = (hotelId) => {
  if (hotelId === undefined || hotelId === null) return null;
  return META_PIXELS[String(hotelId)] || null;
};

export const metaTrack = (hotelId, event, data = {}, eventID) => {
  try {
    if (!META_ENABLED) return;
    const pixelId = getMetaPixelId(hotelId);
    if (!pixelId) return; // hotel has no pixel -> nothing loads, nothing fires

    loadFbq();
    if (!initedPixels.has(pixelId)) {
      // Disable Meta's automatic click/metadata events so nothing
      // fires after the user switches to another hotel
      window.fbq('set', 'autoConfig', false, pixelId);
      window.fbq('init', pixelId);
      initedPixels.add(pixelId);
    }
    // trackSingle targets only this pixel (safe if other pixels exist via GTM)
    if (eventID) {
      window.fbq('trackSingle', pixelId, event, data, { eventID });
    } else {
      window.fbq('trackSingle', pixelId, event, data);
    }
  } catch (e) {
    // swallow: tracking must never break booking
  }
};